import React from 'react';
import { CTooltip } from './StyledComponent';
import { Fade, Icon } from '@mui/material';

function TooltipIcon({ title, icon }) {
    return (
        <CTooltip title={title} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} arrow>
            <Icon>{icon}</Icon>
        </CTooltip>
    );
}

export default TooltipIcon;